/**
 * CreateProjectDialog — "New Slideshow" / "New Song" modal.
 * Behavior fully owned by parent — this is presentational.
 */
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from "@/components/ui/dialog";
import { Music, Presentation } from "lucide-react";

export default function CreateProjectDialog({
  t, open, onOpenChange, name, setName, isSong, setIsSong, onCreate,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            {isSong ? <Music className="w-5 h-5 text-purple-500" /> : <Presentation className="w-5 h-5 text-blue-500" />}
            {isSong ? "New Song" : "New Slideshow"}
          </DialogTitle>
          <DialogDescription>
            {isSong ? "Create worship song slides" : "Create a new presentation"}
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label>{t("project_name")}</Label>
            <Input
              placeholder={isSong ? "Enter song title..." : "Enter project name..."}
              value={name}
              onChange={(e) => setName(e.target.value)}
              onKeyPress={(e) => e.key === "Enter" && onCreate()}
            />
          </div>
          <div className="flex items-center justify-between p-3 bg-slate-50 dark:bg-slate-900 rounded-lg">
            <div>
              <Label>Song/Lyrics Mode</Label>
              <p className="text-xs text-muted-foreground">Optimized for worship lyrics</p>
            </div>
            <Switch checked={isSong} onCheckedChange={setIsSong} />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={onCreate}>{t("create")}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
